if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelector('[id^="GalleryDots"]'),
          mobileThumbs: this.querySelector('.mobile-thumbnail-previews'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        if (this.elements.mobileThumbs) {
        this.elements.mobileThumbs.querySelectorAll('[data-target]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const id = btn.getAttribute('data-target');
            this.setActiveMedia(id, false);
          });
        });
      }

        this.setDimension();

        const firstActiveMedia = this.elements.viewer.querySelector('[data-media-id]');
        this.setActiveMedia.bind(this, firstActiveMedia.getAttribute('[data-media-id]'), false);
      }

      setDimension() {
        this.dimension = 'horizontal';
        if (window.innerWidth >= BREAKPOINTS.tablet && this.elements.thumbnails?.getAttribute('data-dimension-desktop')) {
          this.dimension = this.elements.thumbnails?.getAttribute('data-dimension-desktop');
        }
      }


      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;

        const desktopThumb = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(desktopThumb);

        const mobileBtn = this.elements.mobileThumbs?.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveMobileThumb(mobileBtn);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail?.parentElement?.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages?.();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            const scrollTo = this.dimension === 'vertical'
              ? { top: activeMedia.offsetTop }
              : { left: activeMedia.offsetLeft };
            activeMedia.parentElement.scrollTo(scrollTo);
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });

        this.playActiveMedia(activeMedia);

        // Desktop thumb active + live region
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }

        const mobileBtn = this.elements.mobileThumbs?.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveMobileThumb(mobileBtn);
      }

      setActiveMobileThumb(btn) {
        if (!this.elements.mobileThumbs || !btn) return;

        // Clear actives
        this.elements.mobileThumbs.querySelectorAll('.mobile-thumb[aria-current="true"]')
          .forEach((b) => b.setAttribute('aria-current', 'false'));
        btn.setAttribute('aria-current', 'true');

        // Smoothly center selected thumb in the horizontal scroller
        const rail = this.elements.mobileThumbs;
        const targetLeft = btn.offsetLeft - (rail.clientWidth - btn.clientWidth) / 2;
        rail.scrollTo({ left: targetLeft, behavior: 'smooth' });
      }



      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((el) => {
          el.removeAttribute('aria-current');
          el.closest('li')?.classList?.remove('is-active');
        });
        const btn = thumbnail.querySelector('button');
        btn?.setAttribute('aria-current', 'true');
        btn?.closest('li')?.classList?.add('is-active');

        const mediaId = thumbnail.getAttribute('data-target');
        if (this.elements.dots) {
          this.elements.dots.querySelector(`[data-target].is-active`)?.classList?.remove('is-active');
          this.elements.dots.querySelector(`[data-target="${mediaId}"]`)?.classList?.add('is-active');
        }

        if (typeof this.elements.thumbnails.isSlideVisible === 'function' &&
            this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        const scrollTo = this.dimension === 'vertical'
          ? { top: thumbnail.offsetTop }
          : { left: thumbnail.offsetLeft };
        this.elements.thumbnails.slider?.scrollTo?.(scrollTo);
      }


      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Variant change → scroll v1 media gallery to variant's featured media
(function () {
  if (window._mediaGalleryVariantListenerAdded) return;
  window._mediaGalleryVariantListenerAdded = true;

  window.addEventListener('variant:change', (e) => {
    const { sectionId, variant } = e.detail || {};
    if (!variant || !variant.featured_media) return;
    const mediaId = `${sectionId}-${variant.featured_media.id}`;

    document.querySelectorAll(`[id^="MediaGallery-${sectionId}"]`).forEach((gallery) => {
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, true);
      }
    });
  });
})();
